import { createContext } from "react"
const sale = {
    "client": "",
    "client_name": "",
    "discount_value_input": 0,
    "discount_type": "cash",
    "invoice_type": 1,
    "total_amount": 0,
    "discount_value": 0,
    "paid_value": 0,
    "change": 0,
    "status": 1,
    "items": [],
    "payments": []
}
export default createContext(sale)


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/context.js